import { FIXED_GAME_CONFIG } from '../constants/fixedGameConfig.ts';

export type DailyMode = 'container' | 'survivor';

const CONFIG_FINGERPRINT = [
  FIXED_GAME_CONFIG.gridSize,
  FIXED_GAME_CONFIG.startingFires,
  FIXED_GAME_CONFIG.spreadChance,
  FIXED_GAME_CONFIG.teleportChance,
].join(':');

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) >>> 0;
  }
  return hash || 1;
}

/** UTC calendar day as YYYY-MM-DD */
export function getUtcDayKey(date: Date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

/** Stable daily seed per mode — same for all players on a given UTC day */
export function getDailySeed(mode: DailyMode, dayKey: string = getUtcDayKey()): number {
  return hashString(`${dayKey}:${mode}:${CONFIG_FINGERPRINT}`);
}

/** Milliseconds until next UTC midnight */
export function getMsUntilUtcMidnight(now: Date = new Date()): number {
  const next = new Date(now);
  next.setUTCHours(24, 0, 0, 0);
  return next.getTime() - now.getTime();
}

export function formatUtcCountdown(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
}
